export type Gender = 'male' | 'female';

export type HairstyleId =
  | 'none'
  | 'Hair_SimpleParted'
  | 'Hair_Buns'
  | 'Hair_Long'
  | 'Hair_Buzzed'
  | 'Hair_BuzzedFemale';

export type BeardId = 'none' | 'Hair_Beard';

export type EyebrowsId = 'none' | 'Eyebrows_Regular' | 'Eyebrows_Female';

export type OutfitId = 'none' | 'peasant' | 'ranger';

export type SkinTone = 'light' | 'dark';

export type HairColor = 'black' | 'brown' | 'blonde' | 'red' | 'silver';

export interface CharacterConfig {
  /** Jméno viditelné ostatním hráčům. Server si ho sám ošetří. */
  name: string;
  gender: Gender;
  hairstyle: HairstyleId;
  beard: BeardId;
  eyebrows: EyebrowsId;
  skinTone: SkinTone;
  hairColor: HairColor;
  outfit: OutfitId;
  hood: boolean;
}

export const DEFAULT_CHARACTER: CharacterConfig = {
  name: '',
  gender: 'male',
  hairstyle: 'Hair_SimpleParted',
  beard: 'none',
  eyebrows: 'Eyebrows_Regular',
  skinTone: 'light',
  hairColor: 'brown',
  outfit: 'peasant',
  hood: false,
};

export const OUTFITS_LIST: { id: OutfitId; name: string; desc: string }[] = [
  { id: 'none', name: 'Bez výstroje', desc: 'Základní tělo' },
  { id: 'peasant', name: 'Vesničan', desc: 'Prostá tunika a kalhoty' },
  { id: 'ranger', name: 'Hraničář', desc: 'Kožená zbroj, kápě' },
];

export const HAIRSTYLES_LIST: { id: HairstyleId; name: string; forGender?: Gender }[] = [
  { id: 'none', name: 'Bez vlasů' },
  // Muž
  { id: 'Hair_SimpleParted', name: 'Pěšinka (klasik)', forGender: 'male' },
  { id: 'Hair_Buzzed', name: 'Krátký sestřih', forGender: 'male' },
  // Žena
  { id: 'Hair_Buns', name: 'Drdoly', forGender: 'female' },
  { id: 'Hair_Long', name: 'Dlouhé vlasy', forGender: 'female' },
  { id: 'Hair_BuzzedFemale', name: 'Krátký sestřih', forGender: 'female' },
];

export const BEARDS_LIST: { id: BeardId; name: string }[] = [
  { id: 'none', name: 'Bez vousů' },
  { id: 'Hair_Beard', name: 'Plnovous / bradka' },
];

export const EYEBROWS_LIST: { id: EyebrowsId; name: string; forGender?: Gender }[] = [
  { id: 'none', name: 'Bez obočí' },
  { id: 'Eyebrows_Regular', name: 'Klasické (muž)', forGender: 'male' },
  { id: 'Eyebrows_Female', name: 'Jemné (žena)', forGender: 'female' },
];

export const HAIR_COLORS: { id: HairColor; name: string; hex: number }[] = [
  { id: 'black', name: 'Černá', hex: 0x1a1512 },
  { id: 'brown', name: 'Hnědá', hex: 0x4a3118 },
  { id: 'blonde', name: 'Blond', hex: 0xb59857 },
  { id: 'red', name: 'Zrzavá', hex: 0x8a3818 },
  { id: 'silver', name: 'Stříbrná', hex: 0xa8a8ad },
];
